import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
} from '@material-ui/core';

import { options } from './chart';

const useStyles = makeStyles(() => ({
  root: {},
  chartContainer: {
    height: 400,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const LatestSales = props => {
  const { savings, products, business, share, loans, className, ...rest } = props;
  const classes = useStyles();
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Savings',
        backgroundColor: "blue",
        data: savings
      },
      {
        label: 'Business',
        backgroundColor: "yellow",
        data: business
      },
      {
        label: 'Loans',
        backgroundColor: "red",
        data: loans
      },
      {
        label: 'Products',
        backgroundColor: "black",
        data: products
      },
      {
        label: 'Shares',
        backgroundColor: "orange",
        data: share
      }
    ]
  };
  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader
        // action={
        //   <Button
        //     size="small"
        //     variant="text"
        //   >
        //       <ArrowDropDownIcon />
        //   </Button>
        // }
        title="Monthly Statistic"
      />
      <Divider />
      <CardContent>
        <div className={classes.chartContainer}>
          <Bar
            data={data}
            options={options}
          />
        </div>
      </CardContent>
      <Divider />
    </Card>
  );
};

LatestSales.propTypes = {
  className: PropTypes.string
};

export default LatestSales;
